var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92285 6.49999H16.0771L14.7914 2H9.20856L7.92285 6.49999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64856 2H4.67703C4.26813 2 3.90042 2.24895 3.74856 2.62861L2.20001 6.49999H6.36285L7.64856 2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 6.49999L20.2514 2.62861C20.0996 2.24895 19.7319 2 19.323 2H16.3514L17.6372 6.49999H21.8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.063 9.49999C16.0248 9.3515 16.0025 9.19635 15.9997 9.03662L16.0003 9.0323",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.937 9.49999C15.9752 9.3515 15.9968 9.19634 15.9997 9.03662C15.9999 9.02444 16 9.01223 16 9C16 9.01079 16.0001 9.02155 16.0003 9.0323",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.937 9.49998C15.9024 9.63433 15.8542 9.76322 15.794 9.88509L15.937 9.49998Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.937 9.49999C21.9781 9.34018 22 9.17264 22 8.99999V7.99998L2 7.99999V8.99999C2 9.17264 2.02188 9.34018 2.06301 9.49999C2.28503 10.3626 3.06808 11 4 11H6C6.35133 11 6.68149 10.9094 6.96842 10.7503C7.44259 10.4874 7.79867 10.0374 7.93699 9.49999C7.97812 9.34018 8 9.17263 8 8.99999L8.00026 9.03229C8.00281 9.19355 8.02445 9.35016 8.06301 9.49999C8.20133 10.0374 8.55741 10.4874 9.03158 10.7503C9.31851 10.9094 9.64867 11 10 11H14C14.3513 11 14.6815 10.9094 14.9684 10.7503C15.324 10.5531 15.6133 10.2507 15.794 9.8851L15.937 9.49999L15.9997 9.03661C15.9999 9.02443 16 9.01222 16 8.99999L16.0003 9.03229L16.063 9.49999C16.1094 9.68015 16.1802 9.85047 16.2718 10.0072C16.4533 10.3181 16.7164 10.5755 17.0316 10.7503C17.3185 10.9094 17.6487 11 18 11H20C20.9319 11 21.715 10.3626 21.937 9.49999Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.355C3.31685 12.4493 3.65251 12.5 4 12.5H6C6.74362 12.5 7.43308 12.2681 8 11.8726C8.56692 12.2681 9.25638 12.5 10 12.5H14C14.7436 12.5 15.4331 12.2681 16 11.8726C16.5669 12.2681 17.2564 12.5 18 12.5H20C20.3475 12.5 20.6831 12.4493 21 12.355V21C21 21.5523 20.5523 22 20 22H11V15C11 14.4477 10.5523 14 10 14H6C5.44772 14 5 14.4477 5 15V22H4C3.44772 22 3 21.5523 3 21V12.355ZM13 15V17C13 17.5523 13.4477 18 14 18H18C18.5523 18 19 17.5523 19 17V15C19 14.4477 18.5523 14 18 14H14C13.4477 14 13 14.4477 13 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.b11ddc47575dfdd18c14a6512768295d.svg";
export { ForwardRef as ReactComponent };